module.exports = __webpack_public_path__ + "assets/8e4147f8599c063107162dcb5957ab28.png";